/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIArticleSummary
 */
export interface APIArticleSummary {
    /**
     * 
     * @type {string}
     * @memberof APIArticleSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSummary
     */
    number?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleSummary
     */
    name?: string;
}

/**
 * Check if a given object implements the APIArticleSummary interface.
 */
export function instanceOfAPIArticleSummary(value: object): value is APIArticleSummary {
    return true;
}

export function APIArticleSummaryFromJSON(json: any): APIArticleSummary {
    return APIArticleSummaryFromJSONTyped(json, false);
}

export function APIArticleSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'number': json['number'] == null ? undefined : json['number'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIArticleSummaryToJSON(value?: APIArticleSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'name': value['name'],
    };
}

